export enum StorageKeys {
  approvalHash = 'approvalHash',
  pinHash = 'pinHash',
  scopingSaveHash = 'scopingSaveHash'
}
